import { asyncLoadScript, waitScriptLoaded } from "integrations/helpers";
import { IAuthApi, IAuthPlugin, AuthService } from "shared/mechanics/auth";

import { IPlugin } from "shared/mechanics/plugin";

const clientId = process.env.REACT_APP_INTEGRATION_GOOGLE_AUTH_CLIENT_ID!;

export class GoogleAuthPlugin implements IPlugin, IAuthPlugin {
	name: string = "Google Auth";
	displayName: string = "Google";

	init(): void {
		asyncLoadScript('https://apis.google.com/js/api.js');
	}

	async useAuthentication(): Promise<IAuthApi> {
		await waitScriptLoaded(() => window.gapi ? true : false, 100);

		return new Promise<IAuthApi>((resolve) => {
			const initParams: gapi.auth2.ClientConfig = {
				client_id: clientId,
				scope: 'profile'
			};

			gapi.load('client:auth2', () => {
				gapi.auth2.init(initParams).then(initResult => {
					resolve({
						signIn: async () => {
							const signInResult = await initResult.signIn();

							const userAuthResponse = signInResult.getAuthResponse();
							const userToken = userAuthResponse.id_token;

							await AuthService.signInGoogle(userToken);
						}
					});
				});
			});
		});
	}
};